import { render } from "./AdminOfficesModule.vue?vue&type=template&id=5fa07cae&scoped=true"
import script from "./AdminOfficesModule.vue?vue&type=script&lang=js"
export * from "./AdminOfficesModule.vue?vue&type=script&lang=js"

import "./AdminOfficesModule.vue?vue&type=style&index=0&id=5fa07cae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5fa07cae"

export default script